module.exports = __webpack_public_path__ + "img/login-img3.5884336b.png";